import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { useState } from "react";
import { GD } from "src/GD";
import { FormParser } from "../FormParser";
import { DialogBody, embeddedFormSx, ProviderDialog } from "../providers/providersUi";

export const TerminalEditor = () => {
	useLocale();
	const editorRequestData = GD.S_TERMINAL_EDITOR.use();
	const [busy, setBusy] = useState<boolean>();

	if (!editorRequestData) return null;

	const existing = editorRequestData.terminalID > 0;
	const closePopup = () => {
		GD.B_TERMINALS.execute({ ts: +new Date(), force: true });
		GD.S_TERMINAL_EDITOR.invoke(null);
	};

	return (
		<ProviderDialog width={600} busy={busy} eyebrow={msg("paymentMethod")} title={existing ? msg("editPaymentMethod") : msg("newPaymentMethod")} onClose={closePopup}>
			<DialogBody>
				<FormParser
					appearance="modern"
					sx={embeddedFormSx}
					size="small"
					key={"terminal"}
					onSubmit={async (data: any) => {
						setBusy(true);
						const req = await GD.REQ_API.request({
							method: "terminal/set",
							data: data,
						});
						setBusy(false);
						if (!req.error) GD.S_TERMINALS_UPDATE.invoke();
						return req;
					}}
					onRequest={async () => {
						setBusy(true);
						const req = await GD.REQ_API.request({
							method: "terminal/get",
							data: {
								id: editorRequestData?.terminalID,
							},
						});
						setBusy(false);
						return req;
					}}
					onComplete={closePopup}
				/>
			</DialogBody>
		</ProviderDialog>
	);
};
